import React from 'react';
import PropTypes from 'prop-types';
import { each, isArray } from 'lodash';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';


function CRMPathRenderer(props) {
  const v = props.value;
  const accessible = props.data?.accessible === true;

  if (isArray(v)) {
    const p = [];
    const total = v.length;
    if (!accessible) {
      p.push(<span key="ex"><Fa name="exclamation-triangle" className="text-danger" />&nbsp;</span>);
    }
    
    each(v, (sp, i) => {
      p.push(<code key={`${sp}-label`}>{sp}</code>);
      if (i < total - 1) {
        p.push(<span key={`${sp}-arrow`}><Fa className="text-muted" name="chevron-right" /></span>);
      }
    });

    p.push(<span key="space">{' '}</span>);
    if (accessible) {
      p.push(<span key="type" className="text-uppercase label label-default">{props.data.field_type}</span>);
    } else {
      p.push(<span key="type" className="text-uppercase label label-danger">inaccessible Field</span>);
    }


    if (props.data.description && props.data.description.length > 0) {
      const tip = (
        <Tooltip id={`data-tv-tip-${props.data._id}`}>
          <div>{props.data.description}</div>
        </Tooltip>
      );
      const description = (
        <OverlayTrigger key="tip" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          <Fa name="info-circle" className="text-active" />
        </OverlayTrigger>
      );
      p.push(<span key="space-2">{' '}</span>);
      p.push(description);
    }
    return p;
  }
  return (<code>{v}</code>);
}

CRMPathRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    description: PropTypes.string,
    field_type: PropTypes.string,
    accessible: PropTypes.bool,
  }).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
}

export default CRMPathRenderer;
